// src/utils/favoritesUtils.js
import { doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '../firebase/firestore';

// Кэш для быстрого доступа
const favoritesCache = new Map();

export const addToFavorites = async (userId, product) => {
  try {
    if (!userId || !product.id) {
      throw new Error('Не указан userId или product.id');
    }
    
    const userRef = doc(db, 'telegramUsers', userId);
    
    const favoriteData = {
      productId: product.id,
      title: product.title,
      image: product.image,
      price: product.price,
      discount: product.discount || 0,
      addedAt: new Date(),
      category: product.categories?.[0] || 'Без категории'
    };
    
    await updateDoc(userRef, {
      favorites: arrayUnion(favoriteData)
    });
    
    // Обновляем кэш
    const cacheKey = `${userId}-${product.id}`;
    favoritesCache.set(cacheKey, true);
    
    return true;
  } catch (error) {
    console.error('Error adding to favorites:', error);
    throw error;
  }
};

export const removeFromFavorites = async (userId, productId) => {
  try {
    if (!userId || !productId) {
      throw new Error('Не указан userId или productId');
    }
    
    const userRef = doc(db, 'telegramUsers', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      const favorites = userDoc.data().favorites || [];
      const favoriteToRemove = favorites.find(fav => fav.productId === productId);
      
      if (favoriteToRemove) {
        await updateDoc(userRef, {
          favorites: arrayRemove(favoriteToRemove)
        });
        
        // Обновляем кэш
        const cacheKey = `${userId}-${productId}`;
        favoritesCache.set(cacheKey, false);
      }
    }
    
    return true;
  } catch (error) {
    console.error('Error removing from favorites:', error);
    throw error;
  }
};

export const isInFavorites = async (userId, productId) => {
  try {
    if (!userId || !productId) {
      return false;
    }
    
    // Проверяем кэш
    const cacheKey = `${userId}-${productId}`;
    if (favoritesCache.has(cacheKey)) {
      return favoritesCache.get(cacheKey);
    }
    
    const userRef = doc(db, 'telegramUsers', userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      return false;
    }
    
    const favorites = userDoc.data().favorites || [];
    const isFavorite = favorites.some(fav => fav.productId === productId);
    
    // Сохраняем в кэш
    favoritesCache.set(cacheKey, isFavorite);
    
    return isFavorite;
  } catch (error) {
    console.error('Error checking favorites:', error);
    return false;
  }
};

// Функция для очистки кэша (опционально)
export const clearFavoritesCache = () => {
  favoritesCache.clear();
};